var render = function render(){var _vm=this,_c=_vm._self._c;return _c('DevicesTable',{attrs:{"is-loading":_vm.isLoading,"data":_vm.deviceData,"has-results":_vm.hasResults,"data-title":_vm.startCase(_vm.type),"series":_vm.series}})
}
var staticRenderFns = []

export { render, staticRenderFns }